import {graphql} from 'gatsby';
import moment from 'moment';
import 'moment/locale/pt-br';

class Post {
  static fromMD(data) {
    const post = new Post();

    post.categories = data.frontmatter.categories;
    post.excerpt = data.frontmatter.description;
    post.html = data.html;
    post.keywords = data.frontmatter.keywords_string.split(' ');
    post.ogimage = data.frontmatter.featured_image
      ? data.frontmatter.featured_image.childImageSharp.og
      : null;
    post.thumbnail = data.frontmatter.featured_image
      ? {
        fluid: data.frontmatter.featured_image.childImageSharp.fluid,
        alt: '',
      }
      : null;
    post.time = moment(data.frontmatter.publish_date);
    post.title = data.frontmatter.title;
    post.uri = `/${data.fields.slug}`;

    return post;
  }

  static fromWP(data) {
    const post = new Post();

    post.categories = data.categories.map(cat => cat.name);
    post.excerpt = data.excerpt.replace(/<[^>]*>/g, '');
    post.html = data.content;
    post.keywords = [];
    post.ogimage = null;
    post.thumbnail = null;
    post.time = moment(data.date);
    post.title = data.title;
    post.uri = data.link;

    if (data.featured_media && data.featured_media.localFile) {
      const file = data.featured_media.localFile;
      if (file.childImageSharp) {
        post.ogimage = file.childImageSharp.og;
        post.thumbnail = {
          fluid: file.childImageSharp.fluid,
          alt: data.featured_media.media_details.image_meta.title,
        };
      }
    }

    return post;
  }

  getTime(formatString) {
    return this.time.format(formatString);
  }

  getURL() {
    return `https://samiabomfim.com.br${this.uri}`;
  }
}

export const queries = graphql`
fragment WPPost on wordpress__POST {
  title
  excerpt
  content
  slug
  date
  link
  categories {
    name
  }
  featured_media {
    localFile {
      childImageSharp {
        fluid(maxWidth: 960) {
          ...GatsbyImageSharpFluid
        }

        og: fixed(width: 1200, height: 630) {
          src
          width
          height
        }
      }
    }

    media_details {
      image_meta {
        title
      }
    }
  }
}

fragment MDPost on MarkdownRemark {
  html
  fields {
    slug
  }
  frontmatter {
    categories
    publish_date
    title
    description
    featured_image {
      childImageSharp {
        fluid(maxWidth: 960) {
          ...GatsbyImageSharpFluid
        }

        og: original {
          src
          width
          height
        }
      }
    }
    keywords_string
  }
}
`;

export default Post;
